import { render, staticRenderFns } from "./base-table.vue?vue&type=template&id=d9839020&scoped=true&"
import script from "./base-table.vue?vue&type=script&lang=js&"
export * from "./base-table.vue?vue&type=script&lang=js&"
import style0 from "./base-table.vue?vue&type=style&index=0&id=d9839020&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9839020",
  null
  
)

export default component.exports